<script>
	import Title from './components/Title.svelte'
	import AboutUs from './components/AboutUs.svelte'
	import KeywordDropdown from './components/KeywordDropdown.svelte'
	import ReviewList from './components/ReviewList.svelte'
</script>

<main class="container">
	<Title />
	<AboutUs />
	<KeywordDropdown />
	<ReviewList />
</main>